import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { ITextFieldProps, TextField } from '../../../../ui';

type ILicensePlateNumberProps = Partial<ITextFieldProps> & {
	defaultValue?: string;
};

export const LicensePlateNumber = ({
	defaultValue,
	...props
}: ILicensePlateNumberProps) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = useFormContext();

	return (
		<TextField
			type="text"
			defaultValue={defaultValue}
			label={t('user_form_license_plate_number_label')}
			placeholder={t('user_form_license_plate_number_placeholder')}
			invalid={!!errors.licensePlateNumber}
			error={errors.licensePlateNumber?.message as string}
			autoComplete="off"
			{...register('licensePlateNumber')}
			{...props}
		/>
	);
};
